import { fetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  IContentLibraryIndirectTaxPortalsParams,
  IContentLibraryResponse,
} from './types';

// Hook to fetch indirect tax portals from Content Library
// Returns portals with credential field definitions in metadata
export function useContentLibraryIndirectTaxPortals(
  params: IContentLibraryIndirectTaxPortalsParams | null,
  token?: string
) {
  const cacheKey = params
    ? `content-library/indirect-tax-portals:${params.corporationId}:${params.registrationContentIds.sort().join(',')}`
    : null;

  const { data, mutate, error, isLoading } = useSWR<IContentLibraryResponse>(
    cacheKey,
    async () => {
      if (!params) {
        throw new Error('Params required');
      }
      const response = await fetcher(
        'content-library/indirect-tax-portals',
        { method: 'POST', body: params },
        token
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || 'Failed to fetch portals from content library'
        );
      }
      return response.json();
    }
  );

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
